import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

import Person from './Person';

export default class Comment extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
      richTextResolver: item => `<object text="${item.text}" 
                                               name="${item.author.fullName}" 
                                               position="${
                                                 item.author.position
                                               }" 
                                               url="${item.author.photo}" 
                                               constructor="${
                                                 item.constructor.name
                                               }"/>`
    });
  }

  get author() {
    return get(this, '_pracownik.value[0]', new Person());
  }

  get text() {
    return get(this, '_tekst.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/Comment.js